"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.asArray = exports.isString = exports.pipeAsync = exports.minByOfWithIndex = exports.maxByOf = exports.minOfWithIndex = exports.maxOf = exports.eqValues = exports.moveElementsToFrontOfArray = exports.moveElementToFrontOfArray = exports.doIt = exports.lastOr = exports.headOr = exports.compactNil = exports.compact = exports.isPresent = exports.isBlank = exports.isArray = exports.isNilOrEmpty = exports.isNotNilAndEmpty = exports.isNotNilAndNotEmpty = exports.isNotEmpty = exports.isNotUndefined = exports.isUndefined = exports.isNotNil = exports.isNil = exports.namesOf = exports.idsOf = exports.indexById = exports.maybeReturnProps = exports.getId = exports.findInArrayMap = exports.findTransform = exports.just = void 0;
const ramda_1 = require("ramda");
const ts_utils_1 = require("./ts-utils");
const just = (x, message = "Expected something, got nothing") => {
    (0, ts_utils_1.assertNotNil)(x, message);
    return x;
};
exports.just = just;
function findTransform(array, transform) {
    let element;
    array.some((e, index, array) => {
        element = transform(e, index, array);
        return element !== undefined;
    });
    return element;
}
exports.findTransform = findTransform;
const findInArrayMap = (map, predicate) => {
    const entries = Object.entries(map);
    return (findTransform(entries, ([key, array], index) => {
        const element = array.find((e) => predicate(e, index, array));
        return element ? [key, element] : undefined;
    }) ?? []);
};
exports.findInArrayMap = findInArrayMap;
exports.getId = (0, ramda_1.prop)("id");
const maybeReturnProps = (condition, props) => condition ? props : {};
exports.maybeReturnProps = maybeReturnProps;
const indexById = (xs) => (0, ramda_1.indexBy)(exports.getId, xs);
exports.indexById = indexById;
exports.idsOf = (0, ramda_1.pluck)("id");
exports.namesOf = (0, ramda_1.pluck)("name");
const isNil = (value) => value == null;
exports.isNil = isNil;
const isNotNil = (value) => value != null;
exports.isNotNil = isNotNil;
const isUndefined = (value) => value === undefined;
exports.isUndefined = isUndefined;
const isNotUndefined = (value) => value !== undefined;
exports.isNotUndefined = isNotUndefined;
exports.isNotEmpty = (0, ramda_1.complement)(ramda_1.isEmpty);
const isNotNilAndNotEmpty = (x) => (0, ramda_1.both)(exports.isNotNil, exports.isNotEmpty)(x);
exports.isNotNilAndNotEmpty = isNotNilAndNotEmpty;
const isNotNilAndEmpty = (x) => (0, ramda_1.both)(exports.isNotNil, ramda_1.isEmpty)(x);
exports.isNotNilAndEmpty = isNotNilAndEmpty;
const isNilOrEmpty = (x) => !(0, exports.isNotNilAndNotEmpty)(x);
exports.isNilOrEmpty = isNilOrEmpty;
const isArray = (arg) => Array.isArray(arg);
exports.isArray = isArray;
const isBlank = (x) => (0, ramda_1.is)(String, x)
    ? (0, exports.isNotNilAndEmpty)((0, ramda_1.trim)(x))
    : (0, ramda_1.is)(Boolean, x)
        ? !x
        : x === undefined || x === null
            ? true
            : (0, exports.isNotNilAndEmpty)(x);
exports.isBlank = isBlank;
const isPresent = (x) => (0, ramda_1.complement)(exports.isBlank)(x);
exports.isPresent = isPresent;
function compact(xs) {
    return (0, ramda_1.reject)((x) => x === false || (0, exports.isNil)(x), xs);
}
exports.compact = compact;
exports.compactNil = (0, ramda_1.reject)(exports.isNil);
const headOr = (xs, fallback) => ((0, exports.isNotEmpty)(xs) ? (0, exports.just)((0, ramda_1.head)(xs)) : fallback);
exports.headOr = headOr;
const lastOr = (xs, fallback) => ((0, exports.isNotEmpty)(xs) ? (0, exports.just)((0, ramda_1.last)(xs)) : fallback);
exports.lastOr = lastOr;
const doIt = (fn) => fn();
exports.doIt = doIt;
const moveElementToFrontOfArray = (element, arr) => {
    const elementIndex = arr.findIndex((e) => e === element);
    if (elementIndex === -1)
        return arr;
    return (0, ramda_1.move)(elementIndex, 0, arr);
};
exports.moveElementToFrontOfArray = moveElementToFrontOfArray;
const moveElementsToFrontOfArray = (elements, arr) => (0, ramda_1.reduceRight)(exports.moveElementToFrontOfArray, arr, elements);
exports.moveElementsToFrontOfArray = moveElementsToFrontOfArray;
const eqValues = (list1, list2) => (0, ramda_1.compose)(ramda_1.isEmpty, ramda_1.symmetricDifference)(list1, list2);
exports.eqValues = eqValues;
const maxOf = (xs) => (0, exports.maxByOf)(ramda_1.identity, xs);
exports.maxOf = maxOf;
const minOfWithIndex = (xs) => (0, exports.minByOfWithIndex)(ramda_1.identity, xs);
exports.minOfWithIndex = minOfWithIndex;
const maxByOf = (fn, xs) => {
    (0, ts_utils_1.assertNonEmpty)(xs);
    return (0, ramda_1.reduce)((acc, elem) => (0, ramda_1.maxBy)(fn, acc, elem), xs[0], xs);
};
exports.maxByOf = maxByOf;
const minByOfWithIndex = (fn, xs) => {
    (0, ts_utils_1.assertNonEmpty)(xs);
    return xs.reduce((acc, elem, index) => {
        const minValue = fn(elem);
        return minValue < fn(acc.min) ? { min: elem, index } : acc;
    }, { min: xs[0], index: 0 });
};
exports.minByOfWithIndex = minByOfWithIndex;
exports.pipeAsync = (0, ramda_1.pipeWith)(async (f, res) => f(await res));
const isString = (value) => typeof value === "string";
exports.isString = isString;
function asArray(input) {
    return (0, exports.isNil)(input) ? [] : Array.isArray(input) ? input : [input];
}
exports.asArray = asArray;
//# sourceMappingURL=fpHelpers.js.map